export const STOCK_LOADING = "STOCK_LOADING";
export const STOCK_SUCCESS = "STOCK_SUCCESS";
export const STOCK_FAILURE = "STOCK_FAILURE";